import { Backdrop, CircularProgress } from '@mui/material';

export const AuthLoader = () => (
  <Backdrop
    open
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      color: '#fff',
      borderRadius: 2,
      zIndex: (theme) => theme.zIndex.drawer + 1,
    }}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);
